module.exports = __webpack_public_path__ + "static/media/chat-group-users.ebc30d27.svg";